let _ = t => t,
  _t;
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonBlock = styledWithTheme.div(_t || (_t = _`
  background-color: ${0};
  border-radius: ${0};
  width: ${0};
  height: ${0};
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`), ({
  theme
}) => theme.color['fill-surface-recessed'], ({
  theme
}) => theme.borderRadius['200'], ({
  width
}) => width || '100%', ({
  height
}) => height || '16px');
export const AcademyContentCardSkeleton = ({
  compact
}) => {
  const {
    isMobile
  } = useMediaQuery();
  if (compact !== null && compact !== void 0 ? compact : isMobile) {
    return /*#__PURE__*/_jsx(CardWrapper, {
      compact: true,
      inlineSize: "100%",
      zIndex: 0,
      children: /*#__PURE__*/_jsx(CardSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "400",
          children: [/*#__PURE__*/_jsx(SkeletonBlock, {
            height: "60px",
            width: "60px"
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            flexGrow: 1,
            gap: "200",
            children: [/*#__PURE__*/_jsx(SkeletonBlock, {
              height: "16px",
              width: "80%"
            }), /*#__PURE__*/_jsx(SkeletonBlock, {
              height: "12px",
              width: "40%"
            })]
          })]
        })
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    style: {
      maxWidth: 300
    },
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      borderRadius: "300",
      compact: true,
      zIndex: 0,
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          aspectRatio: '16 / 9',
          width: '100%'
        },
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          height: "100%",
          width: "100%"
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "200",
        padding: "400",
        children: [/*#__PURE__*/_jsx(SkeletonBlock, {
          height: "16px",
          width: "90%"
        }), /*#__PURE__*/_jsx(SkeletonBlock, {
          height: "12px",
          width: "50%"
        }), /*#__PURE__*/_jsxs(Flex, {
          gap: "200",
          marginBlockStart: "200",
          children: [/*#__PURE__*/_jsx(SkeletonBlock, {
            height: "24px",
            width: "60px"
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            height: "24px",
            width: "60px"
          })]
        })]
      })]
    })
  });
};